import { FC, ReactNode, useContext } from 'react';
import { Page } from './ExamDataModal.styles';
import { useTranslation } from 'react-i18next';
import {
  LuxModalHeader,
  LuxModal,
  Stack,
  Typography,
  LuxToggle,
} from '@gemini/fe-ds-core';
import ImportDeviceDataContext from '@context/ImportDeviceDataContext';
import ExamDataHeader from '@pages/ExamImportPage/ExamDataModal/ExamDataHeader/ExamDataHeader';
import ExamDataGrid from '@pages/ExamImportPage/ExamDataModal/ExamDataGrid/ExamDataGrid';

interface ExamDataModalProps {
  children?: ReactNode;
}

const ExamDataModal: FC<ExamDataModalProps> = () => {
  const { t } = useTranslation();
  const { modalOpen, setModalOpen, newExamOnly, setNewExamOnly } = useContext(ImportDeviceDataContext);

  return (
    <Page>
      <LuxModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        hideDraggableItem
        disableOutsideClickClose
        type="bottom"
        header={
          <LuxModalHeader
            title={t('examImport.examData.title')}
            onClose={() => setModalOpen(false)}
            enableCloseIcon
          />
        }
        dragBarHeight="0"
      >
        <>
          <Stack flexDirection={'column'} gap={'1.5rem'} width={'100%'}>
            <ExamDataHeader />
            <Stack
              flexDirection={'row'}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <Typography variant="heading4">
                {t('examImport.examData.table.title')}
              </Typography>
              <LuxToggle
                label={t('examImport.examData.showImportedData')}
                checked={!newExamOnly}
                onChange={(e) => setNewExamOnly(!e.target.checked) }
              />
            </Stack>
            <ExamDataGrid />
          </Stack>
        </>
      </LuxModal>
    </Page>
  );
};

export default ExamDataModal;
